import { render } from "./ResendConfirmation.vue?vue&type=template&id=697d0a93"
import script from "./ResendConfirmation.vue?vue&type=script&lang=js"
export * from "./ResendConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__